export function fixObject(params) {
  let new_params = params.substring(1);
  return JSON.parse(
    '{"' +
      decodeURI(new_params)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  fixObject,
};
